module.exports = __webpack_public_path__ + "media/images/subject_img/DENTISTRY-a8b35b474dc7b2c948543b6a0b2eb7f4.jpg";